import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
// Reuses TrackInfoModal's overlay/panel/row styling - purely presentational,
// generalized here to an arbitrary {label,value}[] instead of a fixed set
// of Track fields.
import '../trackMenu/TrackInfoModal.css';

interface Props {
    title: string;
    rows: [string, string | undefined][];
    onClose: () => void;
}

export function EntityInfoModal({ title, rows, onClose }: Props): React.JSX.Element {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return createPortal(
        <div
            className="trackInfoOverlay"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) onClose();
            }}
        >
            <div className="trackInfoPanel">
                <button className="trackInfoClose" onClick={onClose} aria-label={`Close ${title.toLowerCase()}`}>
                    <X size={16} strokeWidth={2.75} />
                </button>
                <h2 className="trackInfoTitle">{title}</h2>
                <div className="trackInfoRows">
                    {rows
                        .filter(([, value]) => Boolean(value))
                        .map(([label, value]) => (
                            <div className="trackInfoRow" key={label}>
                                <span className="trackInfoLabel">{label}</span>
                                <span className="trackInfoValue">{value}</span>
                            </div>
                        ))}
                </div>
            </div>
        </div>,
        document.body
    );
}
